import { hideAndRemove } from "../../helpers";
import { toggleSceneObject } from "../../togglers";
import { DEFAULT_COUNTS, DRAG_STEPS, Y_MAP_SHELVES } from "./pos_map";

export const changePolkaWardrobes = (count, verticalOnly = true, initDefault = false, preservedY = null) => {
    const height = servObj.tableSize.tableHeight.current;
    const width = servObj.tableSize.tableWidth.current;
    const depth = servObj.tableSize.tableDepth.current;

    const wardrobesName = servObj.tempName;

    const isInstrumentalniy = wardrobesName === "instrumentalniy";
    const wardrobeType = isInstrumentalniy ? "shio" : wardrobesName;
    const instrumentalniyType = servObj.redactorModeObject.userData.loadData.wardrobeType;

    let defaultCount = DEFAULT_COUNTS[wardrobesName][height];

    if (isInstrumentalniy) {
        defaultCount = DEFAULT_COUNTS[wardrobesName][instrumentalniyType];
    }

    if (!initDefault) count += defaultCount;

    const name = `polka__shkaf__${wardrobeType}__${height}x${width}x${depth}__${count}`;

    const currentQuantity = servObj.activePolkaWardrobe.length;
    if (currentQuantity > count && !isInstrumentalniy) {
        servObj.activePolkaWardrobe.forEach((el) => {
            if (el.userData.count > count) {
                hideAndRemove(el);
                servObj.activePolkaWardrobe = servObj.activePolkaWardrobe.filter((item) => item.name !== el.name);
            }
        });
        return;
    }

    const dragStep = DRAG_STEPS[wardrobesName];
    const posY = Y_MAP_SHELVES[wardrobesName]?.[height]?.[count];
    const instrPosY = Y_MAP_SHELVES[wardrobesName]?.[instrumentalniyType]?.[count];

    const position = { y: preservedY ?? (isInstrumentalniy ? instrPosY : posY) };

    toggleSceneObject({
        allObjects: servObj.allPolkaWardrobe,
        activeArray: servObj.activePolkaWardrobe,
        name,
        isChecked: true,
        filterActiveFn: (el) => {
            return el.userData.count < count;
        },
        position,
        userData: { name, count, verticalOnly, dragStep },
        isStrictName: true,
    });
};
